import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../shared/locales/no.json';
import DefaultLayout from '../layout/Default';
import { connect } from 'react-redux';
import { fetchUserCompanies } from './actions/userCompanyActions';
import OnboardingCompanyList from './OnboardingCompanyList';
import { createUrl } from '../../utils/createUrl';
import analytics, * as trackingTypes from '../../actions/analyticsActions';

class Onboarding extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        user: PropTypes.object,
        userCompanies: PropTypes.shape({
            createdCompanyProfile: PropTypes.object,
        }).isRequired,
    };

    componentDidMount() {
        this.props.dispatch(analytics(trackingTypes.VIEW_ONBOARDING));
    }

    static getDerivedStateFromProps(newProps) {
        const { userCompanies } = newProps;
        if (userCompanies.createdCompanyProfile) {
            window.location.href = createUrl(
                `/company/${userCompanies.createdCompanyProfile.id}/edit`
            );
        }
    }

    static fetchData({ dispatch }) {
        return dispatch(fetchUserCompanies());
    }

    onContactEmailCanNotFindMyCompany = () => {
        this.props.dispatch(analytics(trackingTypes.CANT_FIND_COMPANY));
    };

    render() {
        return (
            <DefaultLayout>
                <div className="panel">
                    <h1>{i18n['onbarding heading']}</h1>
                </div>
                <OnboardingCompanyList
                    onContactEmailCanNotFindMyCompany={
                        this.onContactEmailCanNotFindMyCompany
                    }
                    user={this.props.user}
                    userCompanies={this.props.userCompanies}
                />
            </DefaultLayout>
        );
    }
}

export default connect((state) => ({
    userCompanies: state.userCompanies,
    user: state.user,
}))(Onboarding);
